<template>
  <v-container class="app">
    <v-snackbar
      v-model="messageSnackbar"
      :timeout="messageTimeout"
      id="observation_message"
      color="red"
      variant="tonal"
    >
      <div class="text pb-2">{{ observationMessage }}</div>
    </v-snackbar>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="9">
          <v-form ref="observation">
            <DecoyDeploy
              v-if="currentRecord.id !== undefined && currentRecord.id !== ''"
              :selected_record="currentRecord"
              v-on="handler"
            ></DecoyDeploy>
          </v-form>
        </v-col>
        <v-col cols="12" md="3">
          <PhotoList
            v-if="currentRecord.ts != ''"
            :records="currentPhotos"
            v-on="handler"
          />
        </v-col>
      </v-row>
      <v-row v-if="currentRecord.id !== undefined && currentRecord.id !== ''">
        <v-col cols="12">
          <v-btn color="primary" dark @click="save">
            <span>Done</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-tabs v-model="tab" slider-color="blue">
          <v-tab key="mapView">Map</v-tab>
          <v-tab key="listView">List</v-tab>
        </v-tabs>
        <v-window disabled v-model="tab">
          <v-window-item key="map">
            <OpenLayersMap
              :zoom="18"
              :center="[center_longitude_wgs84, center_latitude_wgs84]"
              :latitude="center_latitude_wgs84"
              :longitude="center_longitude_wgs84"
              :pointStyle="pointStyle"
              :idField="idField"
              :points="decoyLocations"
              :selectedId="-999"
              v-on="handler"
            >
            </OpenLayersMap>
          </v-window-item>
          <v-window-item key="list">
            <RecordList :records="records" :fields="fields" v-on="handler" />
          </v-window-item>
        </v-window>
      </v-row>
      <PhotoTypeDialog
        :showPhotoDialog="assignPhotoType"
        v-on="handler"
      ></PhotoTypeDialog>
      <v-dialog v-model="openCamera" fullscreen persistent>
        <TakePhoto
          :previewHeight="600"
          :previewWidth="800"
          :maxheight="maxheight"
          :maxwidth="maxwidth"
          :autoDownload="true"
          :isCameraOpen="openCamera"
          v-on="handler"
        ></TakePhoto>
      </v-dialog>
    </v-col>
  </v-container>
</template>

<script>
import DecoyDeploy from "@/components/DecoyDeploy";
import { RecordList } from "search-observe-app";
import { TakePhoto } from "search-observe-app";
import { PhotoList } from "search-observe-app";
import { PhotoTypeDialog } from "search-observe-app";
import { support } from "search-observe-app";
import { OpenLayersMap } from "search-observe-app";

export default {
  name: "Observation-Form",
  components: {
    DecoyDeploy,
    RecordList,
    TakePhoto,
    PhotoList,
    PhotoTypeDialog,
    OpenLayersMap,
  },
  props: {
    selectedDate: Date,
  },
  data() {
    return {
      handler: {
        record_selected: this.handleSelectedRecord,
        cameraClicked: this.onCameraClicked,
        photoAccepted: this.onPhotoAccepted,
        cameraClose: this.closeCamera,
        photoTypeSet: this.onPhotoTypeAssigned,
        featureSelected: this.handleFeatureSelected,
      },
      tab: null,
      maxwidth: 2200,
      maxheight: 1900,
      messageSnackbar: false,
      messageTimeout: 6000,
      openCamera: false,
      assignPhotoType: false,
      currentPhoto: {},
      idField: "id",
      pointStyle: {
        radius: 5,
        fill: [255, 255, 0, 0.7],
        strokeColor: "red",
        strokeWidth: 1,
      },
    };
  },
  methods: {
    onCameraClicked() {
      this.openCamera = true;
    },
    closeCamera() {
      let tmp =
        this.$store.getters["shared/dataTables"][
          support.data.SURVEYPRIMARYPHOTO
        ];
      console.log(tmp);
      this.openCamera = false;
    },
    onPhotoAccepted(photoInfo) {
      this.currentPhoto = photoInfo;
      this.assignPhotoType = true;
      this.currentPhoto.observation_ts = this.currentRecord.ts;
      this.currentPhoto.survey_tablet = this.currentRecord.survey_tablet;
      this.currentPhoto.ts = support.getLocalTimestamp(new Date());
      support.savePhotoLocally(
        support.data.SURVEYPRIMARYPHOTO,
        this.currentPhoto
      );
    },
    onPhotoTypeAssigned(photoType) {
      this.assignPhotoType = false;
      if (photoType != null) {
        this.currentPhoto.observation_ts = this.currentRecord.ts;
        this.currentPhoto.survey_tablet = this.currentRecord.survey_tablet;
        this.currentPhoto.photo_type = photoType;
        this.currentPhoto.ts =
          this.currentPhoto.ts === "" || this.currentPhoto.ts === undefined
            ? support.getLocalTimestamp(new Date())
            : this.currentPhoto.ts;
        //support.savePhotoLocally(this.getPhotoTable(), this.currentPhoto);
      }
      this.currentPhoto = null;
    },
    handleSelectedRecord(index) {
      this.saveRecord();
      //index is the position of within records, but we need the position in the larger table
      let myId = this.records[index.index]["id"];
      let fullIndex = this.$store.getters["shared/dataTables"][
        support.data.SURVEYPRIMARY
      ].findIndex((obj) => obj.id === myId);

      this.$store.dispatch("shared/shiftPosition", {
        table: support.data.SURVEYPRIMARY,
        position: fullIndex,
      });
    },

    async save() {
      //save the record
      if (this.currentRecord.ts === undefined || this.currentRecord.ts === "") {
        //Don't save observations without a ts
        this.$store.commit("shared/setAttribute", {
          attribute: "observationMessage",
          value:
            "Deployed Time must be filled in before this record can be saved",
        });
        this.messageSnackbar = true;
      } else {
        //wait for the local write to land before submitData reads it back
        //out of localforage, otherwise the upload can race the save and
        //miss the edit that was just made
        await this.saveRecord(support.data.SURVEYPRIMARY, this.currentRecord);
        support.submitData();
        //clear the form by resetting the list position
        this.$store.dispatch("shared/shiftPosition", {
          table: support.data.SURVEYPRIMARY,
          position: -1,
        });
      }
    },
    //Override the support definition for save record
    async saveRecord() {
      let key = `${
        this.$store.getters["shared/dbName"]
      }-${support.tableSpecificKey(
        support.data.SURVEYPRIMARY,
        this.currentRecord
      )}`;
      await support.saveLocal(key, this.currentRecord);
    },
    handleFeatureSelected(feature_id) {
      let index = this.records.findIndex((obj) => obj.id === feature_id);
      this.handleSelectedRecord({ index: index });
    },
  },
  computed: {
    observationMessage() {
      return this.$store.getters["shared/getAttribute"]("observationMessage");
    },
    center_latitude_wgs84() {
      if (this.currentRecord.latitude_wgs84) {
        console.log(
          `${this.currentRecord.longitude_wgs84},${this.currentRecord.latitude_wgs84}`
        );
        return this.currentRecord.actual_latitude_wgs84
          ? this.currentRecord.actual_latitude_wgs84
          : this.currentRecord.latitude_wgs84;
      }
      return this.records.length > 1
        ? this.records
            .map((el) => el.latitude_wgs84)
            .reduce((sum, currentValue) => sum + currentValue, 0) /
            this.records.length
        : this.$store.getters["shared/dataTables"][support.data.SURVEYPRIMARY]
            .slice(0, 20)
            .map((el) => el.latitude_wgs84)
            .reduce(
              (sum, currentValue) =>
                !isNaN(currentValue) ? sum + currentValue : sum,
              0
            ) /
            this.$store.getters["shared/dataTables"][support.data.SURVEYPRIMARY]
              .slice(0, 20)
              .filter((item) => item.latitude_wgs84 > 0).length;
    },
    //center on the average location of the first 20 decoy records if no current records are available
    center_longitude_wgs84() {
      if (this.currentRecord.longitude_wgs84) {
        console.log(
          `${this.currentRecord.longitude_wgs84},${this.currentRecord.latitude_wgs84}`
        );
        return this.currentRecord.actual_longitude_wgs84
          ? this.currentRecord.actual_longitude_wgs84
          : this.currentRecord.longitude_wgs84;
      }
      return this.records.length > 1
        ? this.records
            .map((el) => el.longitude_wgs84)
            .reduce((sum, currentValue) => sum + currentValue, 0) /
            this.records.length
        : this.$store.getters["shared/dataTables"][support.data.SURVEYPRIMARY]
            .slice(0, 20)
            .map((el) => el.longitude_wgs84)
            .reduce(
              (sum, currentValue) =>
                !isNaN(currentValue) ? sum + currentValue : sum,
              0
            ) /
            this.$store.getters["shared/dataTables"][support.data.SURVEYPRIMARY]
              .slice(0, 20)
              .filter((item) => item.latitude_wgs84 > 0).length;
    },
    decoyLocations() {
      //const coordinates = [[-156.442, 20.683235]];
      let geoJson = {
        type: "FeatureCollection",
        features: [],
      };
      this.records.forEach((rec) => {
        geoJson.features.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              rec.actual_longitude_wgs84
                ? rec.actual_longitude_wgs84
                : rec.longitude_wgs84,
              rec.actual_latitude_wgs84
                ? rec.actual_latitude_wgs84
                : rec.latitude_wgs84,
            ],
          },
          properties: {
            id: rec.id,
            placed:
              rec.actual_longitude_wgs84 !== undefined &&
              rec.actual_longitude_wgs84 !== 0
                ? 1
                : 0,
          },
        });
      });
      return geoJson;
    },
    records() {
      return this.$store.getters["shared/dataTables"][
        support.data.SURVEYPRIMARY
      ].filter((item) => {
        //manually parse date to avoid time zone date error
        let dateArray = item["deploy_date"].split("-");
        let itemDate = new Date(
          dateArray[0],
          parseInt(dateArray[1], 10) - 1,
          dateArray[2]
        );
        return itemDate.toDateString() === this.selectedDate.toDateString();
      });
    },
    fields() {
      return support.getFields(support.data.SURVEYPRIMARY);
    },
    currentPhotos() {
      let photo_records =
        this.$store.getters["shared/dataTables"][
          support.data.SURVEYPRIMARYPHOTO
        ];
      let ts = this.currentRecord.ts;
      if (ts !== undefined) {
        return photo_records.filter(function (el) {
          return el["observation_ts"] === ts;
        });
      } else return [];
    },
    currentRecord() {
      if (
        this.$store.getters["shared/tablePositions"][
          support.data.SURVEYPRIMARY
        ] === -1
      ) {
        return {};
      } else {
        return this.$store.getters["shared/dataTables"][
          support.data.SURVEYPRIMARY
        ][
          this.$store.getters["shared/tablePositions"][
            support.data.SURVEYPRIMARY
          ]
        ];
      }
    },
  },
};
</script>
